import HttpError from 'standard-http-error';
import { useCustomAuth } from '../hooks/useCustomAuth';
import { E2E_TEST_SUBJECT } from '../automatedTesting/constants';

export interface Authentication {
  accessToken: string;
  logout: () => void;
  refreshAccessToken: () => Promise<string>;
}

export function useAuthentication(): Authentication {
  const { user, signoutRedirect } = useCustomAuth();
  return {
    accessToken: user?.access_token ?? '',
    logout: () => {
      if (user?.profile.sub === E2E_TEST_SUBJECT) {
        //Can't sign out when we're auto-logged with e2e test user
        return;
      }
      signoutRedirect?.().then();
    },
    refreshAccessToken: async () => {
      if (!user?.access_token) {
        await signoutRedirect?.();

        return Promise.reject(new HttpError(HttpError.UNAUTHORIZED));
      }

      return Promise.resolve<string>(user?.access_token);
    },
  };
}
